import React from 'react'
import 'bootstrap/dist/css/bootstrap.css'
import './skills.css'

function Skills() {
  return (
    <div className='skills '>
      <h2 className='skills-heading'>My Competencies</h2>
      <div className='skills-content'>
      
        <div className='technical '>


          <div className='tech-skills '>
            <div className='tech-skill box-1 ' target='Python'>
             
            </div>
            <div className='tech-skill box-2 '>
              
            </div>
            <div className='tech-skill box-3 '>
              
            </div>
            <div className='tech-skill box-4 '>
              
            </div>
            <div className='tech-skill box-5 '>
              
            </div>
            <div className='tech-skill box-6 '>
              
            </div>
            <div className='tech-skill box-7 '>
              
            </div>
            <div className='tech-skill box-8 '>
              
            </div>
            <div className='tech-skill box-9 '>
              
            </div>
            <div className='tech-skill box-10 '>
              
            </div>
            <div className='tech-skill box-11 '>
              
            </div>
            <div className='tech-skill box-12 '>
              
            </div>
            <div className='tech-skill box-13 '>
              
            </div>
            <div className='tech-skill box-14 '>
              
            </div>
            <div className='tech-skill box-15 '>
              
            </div>
            <div className='tech-skill box-16 '>
              
            </div>
            

          </div>
        </div>
        
        
      </div>
     
    </div>
  )
}

export default Skills
